import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { N8N_INGEST_RUNS_QUERY_KEY } from '@/config/appSettingsKeys'

export interface N8nIngestRunItem {
  id: string
  run_id: string
  folder_key: string | null
  stream: string | null
  ingest_type: string
  src_file_id: string | null
  src_file_name: string | null
  status: string
  error_summary: string | null
  finished_at: string | null
}

export interface N8nIngestRun {
  id: string
  status: string
  triggered_by: string
  trigger_source: string
  force_reprocess: boolean
  files_total: number
  files_succeeded: number
  files_failed: number
  files_skipped: number
  error_summary: string | null
  started_at: string | null
  finished_at: string | null
  created_at: string
  epg_sync_status: string | null
  n8n_ingest_run_items?: N8nIngestRunItem[]
}

export function useN8nIngestRuns(enabled: boolean, limit = 20) {
  return useQuery({
    queryKey: [...N8N_INGEST_RUNS_QUERY_KEY, limit],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('n8n_ingest_runs')
        .select(
          'id, status, triggered_by, trigger_source, force_reprocess, files_total, files_succeeded, files_failed, files_skipped, error_summary, started_at, finished_at, created_at, epg_sync_status, n8n_ingest_run_items(id, run_id, folder_key, stream, ingest_type, src_file_id, src_file_name, status, error_summary, finished_at)'
        )
        .order('created_at', { ascending: false })
        .limit(limit)
      if (error) throw error
      return (data ?? []) as N8nIngestRun[]
    },
    enabled,
    staleTime: 30_000,
  })
}
